<script setup lang="ts"></script>

<template>
  <h2 class="text-16 font-bold">
    <slot></slot>
  </h2>
</template>
